import {days} from "./consts";
import {months} from "./consts";

const OPENWEATHER_HOST = 'https://api.openweathermap.org';
const ONE_CALL_API = `${OPENWEATHER_HOST}/data/2.5/onecall`;
const API_KEY = 'e727b72a36203da805bf1ce55c36d074';

export async function getForecastByCoordinates(coordinates) {
    const apiEndpoint = new URL(ONE_CALL_API);
    const params = {
        lat: coordinates.lat,
        lon: coordinates.lon,
        units: 'metric',
        appid: API_KEY
    };
    apiEndpoint.search = new URLSearchParams(params).toString();

    return fetch(apiEndpoint.href,{
        method: 'get',
    })
        .then(response => response.json())
        .then(result => {
            return result.daily.slice(0, 3);
        })
}

export function timestampToDay(timestamp) {
    const index = new Date(timestamp * 1000).getDay();
    return days[index];
}

export function timestampToDate(timestamp) {
    const dateTime = new Date(timestamp * 1000);
    return `${dateTime.getDate()} / ${months[dateTime.getMonth()]}`;
}
